import { ILinkListItem } from '@/shared/api-client/models/link-list-item';
import _ from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';
import LinkIconComponent from '../link-icon-component/link-icon-component.vue';

@Component({
    components: {
        LinkIconComponent
    }
})
export default class LinkListComponent extends Vue {

    @Prop() public links!: ILinkListItem[];
    @Prop() public show!: boolean;

    /**
     *
     */
    constructor() {
        super();
    }

    public get hasLinks(): boolean {

        if (!this.links) {
            return false;
        }

        if (this.links.length <= 0) {
            return false;
        }

        return true;
    }
}
